<script>
    import TextAttributeBase from './TextAttributeBase';

    export default {
        extends: TextAttributeBase,
        data() {
            return {
                value: null,
            }
        },
        mounted() {
            this.updateValueData = this.attribute.values ? _.get(Object.values(this.attribute.values), '0') : {};
            this.value = this.attribute.values ? _.get(Object.values(this.attribute.values), '0.exists_yes_no') : null;
        },
        methods: {
            store() {
                Vue.nextTick(() => {
                    if (!this.attribute.values || this.attribute.values.length === 0) {
                        this.storeValueData.exists_yes_no = this.value;
                        this.storeValue();
                    } else {
                        this.updateValueData.exists_yes_no = this.value;

                        this.updateValue(false);
                    }
                });
            }
        },
    }
</script>

<template>
    <div :class="[withCols ? 'col-lg-3': '']">
        <div class="panel panel-default">
            <div class="panel-heading">
                <span v-html="headline"></span>
                <i class="pull-right fa fa-lock" v-if="isLocked"></i>
            </div>
            <div class="panel-body">
                <div class="radio">
                    <label>
                        <input :disabled="isLocked" type="radio" :value="1" v-model="value" @click="store">
                        Ja
                    </label>
                </div>
                <div class="radio">
                    <label>
                        <input :disabled="isLocked" type="radio" :value="0" v-model="value" @click="store">
                        Nein
                    </label>
                </div>
            </div>
        </div>
    </div>
</template>